import CommonService from "./common.service";

const logisticsProviderDashboardService = {
  getDashboard: ({ dateFrom, dateTo, module } = {}) => {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (module) params.module = module;
    return CommonService.get("/logistics-provider/dashboard", params);
  },
  getTabNotificationCounts: () =>
    CommonService.get("/logistics-provider/dashboard/tab-notifications", {}, { silent: true }),
};

export default logisticsProviderDashboardService;
